import { useRouter } from 'next/router';

/**
 * Returns sessionId ONLY when on a session page (/scribe/session/*).
 * For chat pages or other pages, returns null.
 *
 * Use this instead of useCurrentSessionId() in chat components
 * to avoid accidentally querying sessions with chat IDs.
 */
export function useChatSessionId(): string | null {
  const router = useRouter();

  // Only return session ID when explicitly on a session page
  if (!router.pathname.startsWith('/scribe/session')) {
    return null;
  }

  const { id: routeId } = router.query;
  return Array.isArray(routeId) ? (routeId[0] ?? null) : (routeId ?? null);
}
